import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    dropdownMenuExaminers: {
      zIndex: 150,
      '& .MuiMenuItem-root': {
        color: '#2C2D3E',
        fontSize: '14px',
        '&:hover': {
          backgroundColor: 'rgba(202, 202, 252, 0.2)',
          color: '#3C419A',
        },
      },
      '& .MuiPaper-elevation8': {
        boxShadow: '0px 4px 10px rgba(44, 45, 62, 0.1)',
        borderRadius: '5px',
      },
    },
    itemRow: {
      display: 'flex',
      marginLeft: '-8px',
      alignItems: 'center',
    },
    iconCol: {
      width: '30px',
      textAlign: 'center',
      marginRight: '5px',
      '& *': {
        margin: 'auto',
      },
    }
  }),
);
